export default {"src":"/_next/static/image/public/assets/feature-images/en/grammar-youre.792c43a444660ade306a1ffada645b17.svg","height":382,"width":520};